import LdfForm from '@features/creation/ldf/components/LdfForm'
import { requirePermission } from '@lib/permissions/guards'
import { createFileRoute } from '@tanstack/react-router'
import { PlusCircle } from 'lucide-react'

export const Route = createFileRoute('/_app/creation/ldf/create')({
  loader: requirePermission('creation.ldf.create'),
  staticData: {
    title: 'Nouvelle LDF',
    icon: PlusCircle,
    permission: 'creation.ldf.create',
    section: 'Creation',
    showInBreadcrumb: true,
  },
  component: CreateLdfPage,
})

function CreateLdfPage() {
  return (
    <div className="max-w-3xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold">Nouvelle Liste de Fabrication</h1>
        <p className="text-sm text-base-content/60">
          Créer une nouvelle LDF pour un article
        </p>
      </div>
      <LdfForm />
    </div>
  )
}